import {
  GET_SOLR_RESULT,
  UPDATE_SOLR_RESULT,
  TOGGLE_SOLR_FACET,
  SET_SOLR_TYPE_PARAMS,
  SET_SOLR_SEARCH,
} from '../../constants/ActionTypes';

export function getSolrResult(data) {
  const path = '/@get_solr_result';

  return {
    type: GET_SOLR_RESULT,
    request: {
      op: 'post',
      path: path,
      data: data,
    },
  };
}

export function updateSolrResult(data) {
  const path = '/@update_solr_result';

  return {
    type: UPDATE_SOLR_RESULT,
    request: {
      op: 'post',
      path: path,
      data: data,
    },
  };
}

export function setSolrSearch(search) {
  return {
    type: SET_SOLR_SEARCH,
    result: { search: search },
  };
}

export function toggleSolrFacet(facetId, facetValueId) {
  return {
    type: TOGGLE_SOLR_FACET,
    result: { facetId: facetId, facetValueId: facetValueId },
  };
}

export function setSolrTypeParams(contentType, reviewState, params) {
  return {
    type: SET_SOLR_TYPE_PARAMS,
    result: {
      contentType: contentType,
      reviewState: reviewState,
      params: params,
    },
  };
}
